(() => {
  if (!['red-bull-extreme-honey','loriz-premium-shilajit-honey','premium-honey-sachets-individually-packed','php-royal-honey-supplement'].includes(window.location.pathname.replace(/\/$/, '').split('/').pop())) return;
  const selector = '.jdgm-write-review-modal__compact-body';
  const enableDirectEntry = () => {
    const prototype = window.jdgm?._WriteReviewModal?.prototype;
    if (!prototype || prototype.rhpDirectEntry || typeof prototype._determineStartingPage !== 'function') return;
    const original = prototype._determineStartingPage;
    prototype._determineStartingPage = function (...args) {
      const page = original.apply(this, args);
      const params = new URLSearchParams(window.location.search);
      const specialLink = [...params.keys()].some(key => key.startsWith('judgeme_'));
      const settings = window.jdgmSettings || {};
      return page === 1 && this._compactMode && !this.isLeavingShopReview &&
        !this.otherProductContext && !this.isPreVerified && !specialLink &&
        !window.jdgm?.followUpToken && !settings.require_verification_before_submit &&
        !settings.sign_in_with_shop_enabled ? 2 : page;
    };
    prototype.rhpDirectEntry = true;
  };
  const moveBefore = (first, second) => {
    if (!first || !second || first.parentElement !== second.parentElement) return;
    if (second.compareDocumentPosition(first) & Node.DOCUMENT_POSITION_FOLLOWING) {
      second.before(first);
    }
  };
  const arrange = body => {
    body.querySelectorAll('#jdgm-review-title-input,#jdgm-review-body-input,#jdgm-name-input,#jdgm-email-input').forEach(input => {
      if (input.hasAttribute('placeholder')) input.removeAttribute('placeholder');
    });
    const labels = {
      'jdgm-review-body-input': 'Review Description',
      'jdgm-name-input': 'Name',
      'jdgm-email-input': 'Email Address'
    };
    Object.entries(labels).forEach(([id, text]) => {
      const label = body.querySelector(`label[for="${id}"]`);
      if (label && label.textContent.trim() !== text) label.textContent = text;
    });
    const profile = body.querySelector('.jdgm-write-review-modal__page--about-you');
    const profileTitle = profile?.querySelector('.jdgm-write-review-modal__title');
    if (profileTitle && profileTitle.textContent.trim() !== 'Your Profile') profileTitle.textContent = 'Your Profile';
    if (profile && profile.getAttribute('aria-label') !== 'Your Profile') {
      profile.setAttribute('role', 'group');
      profile.setAttribute('aria-label', 'Your Profile');
    }
    const modal = body.closest('.jdgm-write-review-modal');
    const content = modal?.querySelector('.jdgm-write-review-modal__content');
    if (content && !content.querySelector('.lohriz-review-brand')) {
      const brand = document.createElement('div');
      brand.className = 'lohriz-review-brand';
      brand.textContent = 'LOHRIZ';
      content.prepend(brand);
    }
    if (content && document.documentElement.classList.contains('lohriz-review-page') &&
      !content.querySelector('.lohriz-review-return')) {
      const back = document.createElement('a');
      back.className = 'lohriz-review-return';
      back.href = `${window.location.pathname}#rhp-product-reviews`;
      back.textContent = 'Back to product';
      content.append(back);
    }
    const header = body.querySelector('.jdgm-write-review-modal__page--review-details .jdgm-write-review-modal__page-header');
    const galleryImage = document.querySelector('.catalog-product-gallery img');
    if (header && galleryImage && !header.querySelector('.lohriz-review-product-image')) {
      const image = document.createElement('img');
      image.className = 'lohriz-review-product-image';
      image.src = galleryImage.currentSrc || galleryImage.src;
      image.alt = galleryImage.alt;
      image.width = image.height = 80;
      header.prepend(image);
    }
    const field = id => body.querySelector(id)?.closest('.jdgm-write-review-modal__field-group');
    moveBefore(field('#jdgm-review-title-input'), field('#jdgm-review-body-input'));
    moveBefore(field('#jdgm-name-input'), field('#jdgm-email-input'));
    moveBefore(body.querySelector('.jdgm-write-review-modal__page--share-media'),
      body.querySelector('.jdgm-write-review-modal__page--about-you'));
  };
  const boot = () => {
    const ownerDocument = document;
    const modalSelector = '.jdgm-write-review-modal';
    const standalone = ownerDocument.documentElement.classList.contains('lohriz-review-page');
    const loading = ownerDocument.querySelector('.lohriz-review-loading');
    const status = loading?.querySelector('[data-review-page-status]');
    const retry = loading?.querySelector('[data-review-page-retry]');
    let opened = false, loadTimer, readyEntryRequested = false;
    const openPageForm = () => {
      const entry = ownerDocument.querySelector('button[data-write-review]');
      if (!entry) return;
      if (status) status.textContent = 'Loading your review form…';
      if (retry) retry.hidden = true;
      entry.click();
      window.clearTimeout(loadTimer);
      loadTimer = window.setTimeout(() => {
        if (loading && !loading.hidden) {
          if (status) status.textContent = 'The review form is taking longer to load. Please try again.';
          if (retry) retry.hidden = false;
        }
      }, 15000);
    };
    if (standalone) {
      // Keep the localized title supplied by the SEO template.
      retry?.addEventListener('click', openPageForm);
      // Run after the deferred product review entry handlers have initialized.
      window.setTimeout(openPageForm, 0);
    }
    let closingModal = null, pendingEntry = null;
    const markClosing = modal => {
      if (modal && getComputedStyle(modal).display !== 'none') closingModal = modal;
    };
    ownerDocument.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      if (pendingEntry) pendingEntry = null;
      markClosing([...ownerDocument.querySelectorAll(modalSelector)].find(modal =>
        getComputedStyle(modal).display !== 'none'));
    }, true);
    ownerDocument.addEventListener('click', event => {
      const target = event.target.closest?.('[data-write-review], .jdgm-write-review-modal__close-btn, .jdgm-write-review-modal__nav-btn-close');
      if (!target) return;
      if (!target.matches('[data-write-review]')) { markClosing(target.closest(modalSelector)); return; }
      if (!closingModal) return;
      // Wait for Judge.me to replace the old form, then use the normal entry
      // handler. A fading modal otherwise makes that handler skip reopening.
      pendingEntry = target;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    const resumeEntry = () => {
      if (!closingModal || closingModal.isConnected) return;
      const replacement = ownerDocument.querySelector(`${modalSelector} ${selector}`);
      if (!replacement) return;
      const entry = pendingEntry;
      closingModal = pendingEntry = null;
      if (entry?.isConnected) entry.click();
    };
    const syncSubmitNames = () => {
      ownerDocument.querySelectorAll(`${modalSelector} .jdgm-write-review-modal__stars`).forEach(group => {
        // Read the committed vendor score, not hover-preview star classes.
        const score = Number(group.querySelector('input[name="score"]')?.value || 0);
        group.querySelectorAll('button.jdgm-star[data-alt]').forEach(button => {
          button.type = 'button';
          const pressed = String(Number(button.dataset.alt) === score);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        });
      });
      ownerDocument.querySelectorAll(`${modalSelector} .jdgm-write-review-modal__nav-btn-next`).forEach(button => {
        const label = button.textContent.trim();
        if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
    };
    ownerDocument.addEventListener('click', event => {
      if (event.target.closest?.(`${modalSelector} .jdgm-star`)) {
        // Vendor listeners commit the score during this activation.
        window.setTimeout(syncSubmitNames, 0);
      }
      const next = event.target.closest?.(`${modalSelector} .jdgm-write-review-modal__nav-btn-next`);
      if (next) window.setTimeout(() => {
        const body = next.closest(modalSelector)?.querySelector(selector);
        if (!body) return;
        // The vendor validates email before name; our visible order is name first.
        const invalid = [...body.querySelectorAll('[aria-invalid="true"]')].find(field => {
          const rect = field.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < window.innerWidth;
        });
        const target = invalid?.matches('input,textarea,select,button')
          ? invalid : invalid?.querySelector('button,input,textarea,select');
        if (target && ownerDocument.activeElement !== target) target.focus();
      }, 0);
    });
    const syncScrollLock = () => {
      if (!ownerDocument.documentElement) return;
      enableDirectEntry();
      const open = [...ownerDocument.querySelectorAll(modalSelector)].some(modal =>
        getComputedStyle(modal).display !== 'none' && !modal.hidden &&
        (!standalone || modal.style.display === 'block'));
      ownerDocument.documentElement.classList.toggle('rhp-review-modal-open', open);
      if (standalone && loading) {
        const wasOpen = loading.hidden;
        if (loading.hidden !== open) loading.hidden = open;
        if (open) { opened = true; window.clearTimeout(loadTimer); }
        else if (opened) {
          if (status && status.textContent !== 'Your review form is closed.') status.textContent = 'Your review form is closed.';
          if (retry?.hidden) retry.hidden = false;
          if (wasOpen) retry?.focus();
        } else if (!readyEntryRequested && [...ownerDocument.querySelectorAll(modalSelector)].some(modal =>
          modal.querySelector(selector) && getComputedStyle(modal).display === 'none' &&
          getComputedStyle(modal).position === 'fixed')) {
          // The first activation also downloads the vendor widget. Its form
          // can mount after the entry handler's retry window has elapsed.
          readyEntryRequested = true;
          window.setTimeout(() => {
            if (![...ownerDocument.querySelectorAll(modalSelector)].some(modal => modal.style.display === 'block')) openPageForm();
          }, 0);
        }
      }
    };
    document.querySelectorAll(selector).forEach(arrange);
    syncScrollLock();
    syncSubmitNames();
    if (standalone) ownerDocument.addEventListener('load', event => {
      if (event.target.tagName === 'LINK') syncScrollLock();
    }, true);
    // Judge.me creates and can remount modal sections asynchronously. Move the
    // existing nodes only: labels, validation, upload state and listeners survive.
    new MutationObserver(records => {
      resumeEntry();
      syncSubmitNames();
      const bodies = new Set();
      if (records.some(record => record.type === 'childList' || record.target.matches?.(modalSelector))) syncScrollLock();
      records.forEach(record => {
        if (record.type !== 'childList') return;
        const containingBody = record.target.closest?.(selector);
        if (containingBody) bodies.add(containingBody);
        record.addedNodes.forEach(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches(selector)) bodies.add(node);
          node.querySelectorAll(selector).forEach(body => bodies.add(body));
        });
      });
      bodies.forEach(arrange);
    }).observe(document.body, {childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-label']});
  };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, {once: true}) : boot();
})();
